import { defineStore } from 'pinia'

export type ToastType = 'success' | 'error'

export interface ToastItem {
  id: number
  type: ToastType
  message: string
  duration: number
}

const DEFAULT_DURATION = 5000

let nextId = 1

export const useToastStore = defineStore('toast', {
  state: () => ({
    items: [] as ToastItem[],
  }),

  actions: {
    push(type: ToastType, message: string, duration: number = DEFAULT_DURATION) {
      const text = (message ?? '').toString().trim()
      if (!text) return
      const id = nextId++
      this.items.push({ id, type, message: text, duration })
      return id
    },

    success(message: string, duration?: number) {
      return this.push('success', message, duration)
    },

    error(message: string, duration?: number) {
      return this.push('error', message, duration)
    },

    dismiss(id: number) {
      const idx = this.items.findIndex((t) => t.id === id)
      if (idx !== -1) this.items.splice(idx, 1)
    },

    clear() {
      this.items = []
    },
  },
})
